module.exports = __webpack_public_path__ + "static/media/20x104.3a1f2782.png";